import { useQuery, useSession } from 'common/hooks';
import { UseQueryOptions } from 'common/types/Api.type';
import { getPreviousWinPeriodApi } from 'features/projects/services/win-periods.service';

export const useGetPreviousWinPeriod = (options?: UseQueryOptions) => {
  const { account: user } = useSession();
  const queryResponse = useQuery(
    ['previous-win-period', user.organizationId],
    getPreviousWinPeriodApi,
    options,
  );

  return {
    ...queryResponse,
    data: queryResponse.isSuccess ? queryResponse?.data.data : {},
  };
};
